import PaginatorSwitcher from './view/desktop/PaginatorSwitcher';

export default PaginatorSwitcher;
